var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem","margin-bottom":"20px"},attrs:{"variant":"primary","label":"Large Spinner"}}),_c('p',[_vm._v("準備中です。少々お待ちください。")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }